import React, { useEffect, useRef } from "react";
import { Button, Col, Form } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { useErrorContext } from "../contexts/ErrorContext";
import { useMsgContext } from "../contexts/MsgContext";
import { useRegisterContext } from "../contexts/RegisterContext";
import "../css/formulario.css";
import { Get, ValidEmail } from "../Utils/Helpers";
import { FetchResponse } from "../Utils/Types";

const RegisterForm = () => {
	const { cuil, setCuil, cuilValido, setRegistrandose, mail, setMail } = useRegisterContext();
	const { setErrorMsg } = useErrorContext();
	const { setMsg } = useMsgContext();

	const refCuil = useRef<NumberFormat>(null);
	const refMail = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (cuil && cuil.replaceAll("_", "").length === 13) {
			refMail.current?.focus();
		}
	}, [cuil]);

	const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();

		if (!ValidEmail(mail)) {
			setErrorMsg(
				"La casilla de correo electrónico, no tiene un formato válido. Verifique he intente nuevamente."
			);
			refMail.current?.focus();
			return;
		}

		const result: FetchResponse = await Get(`/Registro/${cuil}/${mail}`);

		if (result.error) {
			setErrorMsg(result.ErrorMsg);
			return;
		}

		if (!result.resultados) {
			setErrorMsg("Hubo un problema al querer dar de alta. Por favor, vuelva a intentar dentro de unos minutos.");
			return;
		}

		setRegistrandose(false);

		setMsg(
			`¡Registro correcto! Ahora debe esperar a que validemos que los datos sean correctos y le estaremos enviando a la casilla indicada los datos para poder ingresar por primera vez.`
		);

		goBack();
	};

	useEffect(() => {
		if (cuil && cuil.replaceAll("_", "").length === 13) {
			refMail.current?.focus();
		}
	}, [cuil]);

	const handleCuilOnChange = (v: React.ChangeEvent<HTMLInputElement>) => {
		setCuil(v.target.value);
	};

	const handleMailOnChange = (v: React.ChangeEvent<HTMLInputElement>) => {
		setMail(v.target.value);
	};

	const goBack = () => {
		setCuil("");
		setMail("");
		setRegistrandose(false);
	};

	return (
		<Col className='formulario-contenedor'>
			<div className='formulario'>
				<Form>
					<Form.Group className='mb-3' controlId='formBasicEmail'>
						<Form.Label>CUIL</Form.Label>
						<NumberFormat
							format='##-########-#'
							mask='_'
							className='form-control email-input'
							placeholder='Ingrese su CUIL'
							value={cuil}
							onChange={handleCuilOnChange}
							allowEmptyFormatting
							autoFocus
							ref={refCuil}
						/>
					</Form.Group>

					<Form.Group className='mb-3' controlId='formBasicmailword'>
						<Form.Label>Contraseña</Form.Label>
						<Form.Control
							type='text'
							placeholder='Casilla de Correo electrónico'
							className='clave-input'
							value={mail}
							onChange={handleMailOnChange}
							ref={refMail}
						/>
					</Form.Group>
					<Button variant='primary' type='submit' size='lg' onClick={handleSubmit} disabled={!cuilValido}>
						Confirmar Datos
					</Button>
					<Button
						variant='link'
						className='btn-registrarse'
						onClick={(e) => {
							e.preventDefault();
							goBack();
						}}
					>
						Cancelar
					</Button>
				</Form>
			</div>
		</Col>
	);
};

export default RegisterForm;
